/* src/app/components/control-module/process-card/process-card.component.css */
.prepare-truncate {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  white-space: normal;
  -webkit-line-clamp: 1;
}
.card:hover {
  display: block;
  padding: 45px 0;
  border-radius: 5px;
  box-shadow: 0 0px 4px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
}
.card_header {
  background-color: var(--navy-500);
  padding: 5px 0px 5px 0px;
}
.company_title {
  color: var(--bg-surface);
  font-size: 17px;
  font-weight: 600;
}
.tax_id {
  color: var(--gray-100);
  font-size: 14px;
  font-weight: 600;
}
.programmation {
  background-color: var(--success);
  border-radius: 0px 0px 5px 5px;
}
.evaluation {
  background-color: var(--warning);
  border-radius: 0px 0px 5px 5px;
}
.execution {
  background-color: var(--navy-600);
  border-radius: 0px 0px 5px 5px;
}
.comment {
  font-size: 15px;
  background-color: var(--navy-50);
  border-radius: 4px;
  padding: 6px;
  color: var(--navy-500);
  font-style: italic;
}
.action-button-style {
  width: fit-content;
  float: left;
  max-height: 40px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/*# sourceMappingURL=process-card.component.css.map */
